export const handleInputChange = (e, setForm, Inputs, setErrors, form, setImageUrlLocal) => {
  const { name, value, files } = e.target;

  if (files && files.length > 0) {
    const selectedFile = files[0];

    // Actualizar el estado del formulario con el archivo seleccionado
    setForm((prevForm) => ({
      ...prevForm,
      [name]: selectedFile,
    }));

    // Si es el campo de imagen, generar la vista previa
    if (name === 'mar_imagen') {
      const imageUrl = URL.createObjectURL(selectedFile);
      setImageUrlLocal(imageUrl);
    }

    // Limpiar errores si hay archivo
    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  } else {
    let inputValue = value;

    // Convertir valores booleanos si es necesario
    if (name === "vista") {
      inputValue = value === "true"; // Convertir "true" o "false" a booleano
    }

    setForm((prevForm) => ({
      ...prevForm,
      [name]: inputValue,
    }));

    // Validación de los campos
    const inputConfig = Inputs.find((input) => input.name === name);

    if (inputConfig && inputConfig.validation) {
      const error = inputConfig.validation(value, form);
      setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    }
  }
};
